import styled from 'styled-components';
import { ActionButton, ButtonProps } from './Button';

export const StyledBackButton = styled(ActionButton)`
  position: absolute;
  left: -48px;
`;

export const BackButton = (props: ButtonProps) => (
  <StyledBackButton icon="la la-arrow-left" {...props} />
);
